import { Loader } from '@sgme/ui';
import { BlotterPanelBodyLayout } from 'components/shared/Blotter/BlotterPanel/BlotterPanelBody/BlotterPanelBodyLayout';
import { BlotterPanelHeaderLayout } from 'components/shared/Blotter/BlotterPanel/BlotterPanelHeader/BlotterPanelHeaderLayout';
import { ButtonsGroup } from 'components/shared/ButtonsGroup/ButtonsGroup';
import { OverviewFooter } from 'components/shared/ScheduledRun/Blotter/panel/Overview/OverviewFooter';
import { ConnectedOverviewTab } from 'components/shared/ScheduledRun/Blotter/panel/Overview/OverviewTab';
import { QuotesFooter } from 'components/shared/ScheduledRun/Blotter/panel/Quotes/QuotesFooter';
import { QuotesTab } from 'components/shared/ScheduledRun/Blotter/panel/Quotes/QuotesTab';
import {
  connectScheduledQuotesBlotterPanel,
  type ScheduledQuotesBlotterPanelProps,
} from 'components/shared/ScheduledRun/Blotter/panel/ScheduledQuotesBlotterPanel.connect';
import { SchedulesFooter } from 'components/shared/ScheduledRun/Blotter/panel/Schedules/SchedulesFooter';
import { ConnectedSchedulesTab } from 'components/shared/ScheduledRun/Blotter/panel/Schedules/SchedulesTab';
import { ScheduleStatusBadge } from 'components/shared/ScheduledRun/shared/ScheduleStatusBadge';
import { FC, ReactNode } from 'react';
import { SCHEDULE_PANEL_TAB } from 'state/blotters/scheduledQuotes';

export function ScheduledQuotesBlotterPanel({
  status,
  onClosed,
  name,
  selectedPanelTab,
  selectPanelTab,
  updateStatus,
}: ScheduledQuotesBlotterPanelProps) {
  return (
    <Panel>
      <BlotterPanelHeaderLayout
        onClosed={onClosed}
        bottom={
          <ButtonsGroup
            items={SCHEDULE_PANEL_TAB}
            selectedItems={selectedPanelTab}
            isRadio
            className="w-100 btn-group-lg"
            onSelect={tabs => selectPanelTab(tabs[0])}
          />
        }
      >
        <>
          <h3 className="card-title line-height-1 flex-grow-1 align-items-center d-flex">
            {name}{' '}
            {updateStatus === 'loading' && (
              <div className="ms-2">
                <Loader purpose="spinner" size={'sm'} />
              </div>
            )}
          </h3>
          <div className="d-flex align-items-center">
            <ScheduleStatusBadge status={status} />
          </div>
        </>
      </BlotterPanelHeaderLayout>
      <BlotterPanelBodyLayout>
        {selectedPanelTab === 'overview' && <ConnectedOverviewTab />}
        {selectedPanelTab === 'quotes' && <QuotesTab />}
        {selectedPanelTab === 'schedules' && <ConnectedSchedulesTab />}
      </BlotterPanelBodyLayout>
      <Footer>
        {selectedPanelTab === 'overview' && <OverviewFooter />}
        {selectedPanelTab === 'quotes' && <QuotesFooter />}
        {selectedPanelTab === 'schedules' && <SchedulesFooter />}
      </Footer>
    </Panel>
  );
}

export const ConnectedScheduledQuotesBlotterPanel = connectScheduledQuotesBlotterPanel(ScheduledQuotesBlotterPanel);

const Panel: FC<{
  children: ReactNode;
}> = ({ children }) => {
  return (
    <div className="card bg-lvl1 h-100 border-start border-top d-flex flex-column" data-e2e="blotter-panel">
      {children}
    </div>
  );
};

export const Footer: FC<{
  children: ReactNode;
  className?: string;
}> = ({ className, children }) => {
  return <div className={className}>{children}</div>;
};
